module.exports = __webpack_public_path__ + "static/media/cherries_jam.aba61e41.png";